import dayjs from 'dayjs';
import React from 'react';
import { PopoverContent, PopoverTitle } from 'react-bootstrap';
import { LedgerType } from 'src/pages/pto/types';

interface IProps {
    ledgerItem: LedgerType;
    employee: boolean;
    employeeCommentDate: dayjs.Dayjs;
    managerCommentDate: dayjs.Dayjs;
}

const PTOShowComment: React.FC<IProps> = (props) => {
    const { ledgerItem, employee, employeeCommentDate, managerCommentDate } = props;

    return(
        <>
            <PopoverTitle className='pto-popover-title' as="h5" style={{ backgroundColor: "#E9E9E9"}} >
                    {
                        employee ?
                            "Employee Comment"
                            : "Manager Comment"
                    }                
            </PopoverTitle>
            {
                employee ?
                    <PopoverContent className="pto-popover-content">
                        <div className='pto-popover-textarea'>{ledgerItem.employeeComment}</div> 
                        {
                            (ledgerItem.EmployeeCommentDatets > 946684800000 || ledgerItem.ManagerCommentDatets > 946684800000) ?
                                <p className='popover-comment-text'>Added by {ledgerItem.EmployeeCommenterName} at {employeeCommentDate.local().format('MM/DD/YYYY hh:mm a')}</p>
                                : <p className='popover-comment-text'>Added prior to comment date/time tracking</p>
                        }                       
                    </PopoverContent>
                    : 
                    <PopoverContent className="pto-popover-content">
                        <div className='pto-popover-textarea'>{ledgerItem.managerComment}</div>
                        {
                            (ledgerItem.EmployeeCommentDatets > 946684800000 || ledgerItem.ManagerCommentDatets > 946684800000) ?
                                <p className='popover-comment-text'>Added by {ledgerItem.ManagerCommenterName} at {managerCommentDate.local().format('MM/DD/YYYY hh:mm a ')}</p>
                                : <p className='popover-comment-text'>Added prior to comment date/time tracking</p>
                        }
                    </PopoverContent>
            }
        </>
    )
}
export default PTOShowComment;